import React from 'react';
import { connect } from 'react-redux';

import { track } from '@ha/analytics';

type ResultType = (name: string, data?: any) => ReturnType<typeof track>;

export const useTrackEvent = (): ResultType => {
  return React.useCallback((...args) => track(...args), []);
};

export const withTrackEvent = connect(null, {
  track,
});
